import React, {useCallback, useEffect, useMemo, useRef} from "react";
import {Box} from "@mui/material";
import JoditEditor from "jodit-react";
import {useSelector} from "react-redux";
import {appConfigSelector} from "../../state/app-config/appConfigSelectors";
import {languageSelector} from "../../state/app/appSelectors";
import "./style.css";

const defaultButtons = [
  "undo",
  "redo",
  "|",
  "find",
  "selectall",
  "|",
  "paragraph",
  "fontsize",
  "font",
  "brush",
  "|",
  "bold",
  "italic",
  "underline",
  "strikethrough",
  "eraser",
  "|",
  "symbols",
  "hr",
  "link",
  "image",
  "video",
  "table",
  "|",
  "align",
  "|",
  "ul",
  "ol",
  "indent",
  "outdent",
  "|",
  "source"
];

const HtmlEditor = ({value, onChange, disabled, height = 400}) => {
  const language = useSelector(languageSelector);
  const htmlEditorConfig = useSelector(appConfigSelector)?.htmlEditor;

  const config = useMemo(() => {
    const buttons = htmlEditorConfig?.toolbarItems ?? defaultButtons;

    return {
      readonly: !!disabled,
      language: language || "en",
      buttons: buttons,
      buttonsMD: buttons,
      buttonsSM: buttons,
      buttonXS: buttons,
      toolbarAdaptive: false,
      toolbarSticky: true,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      addNewLine: false,
      showPlaceholder: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: "insert_clear_html",
      uploader: {
        insertImageAsBase64URI: true
      },
      imageProcessor: {
        replaceDataURIToBlobIdInView: false
      },
      filebrowser: {
        ajax: {
          url: ""
        }
      },
      height: height,
      allowResizeX: false,
      allowResizeY: false
    };
  }, [htmlEditorConfig, language, disabled, height]);

  const handleBlur = useCallback(newContent => onChange(newContent), [onChange]);

  const editorRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (wrapperRef.current && editorRef.current) {
      editorRef.current.options.popupRoot = wrapperRef.current;
    }
  }, []);

  return (
    <Box ref={wrapperRef} className={"html-editor-container"}>
      <JoditEditor ref={editorRef} tabIndex={1} config={config} value={value || ""} onBlur={handleBlur} />
    </Box>
  );
};

export default HtmlEditor;
